import { render } from "./DragSortImageUploader.vue?vue&type=template&id=1198445f&ts=true"
import script from "./DragSortImageUploader.vue?vue&type=script&lang=ts"
export * from "./DragSortImageUploader.vue?vue&type=script&lang=ts"

import "./DragSortImageUploader.vue?vue&type=style&index=0&id=1198445f&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__